<template>
  <div>
    <div class="d-flex" id="wrapper">
      <!-- Sidebar -->
      <SideBar/>
      <!-- /#sidebar-wrapper -->
      <!-- Page Content -->
      <div id="page-content-wrapper">
       <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
          <div>
            <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
            </button>

            <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
            </button>
          </div>
          <div class="d-flex">
            <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
            <p class="text-primary mb-0 hover-cursor">&nbsp;Product</p>
          </div>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ admin }}
                </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                  <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                  <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                </div>
              </li>
            </ul>
          </div>
        </nav>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card card-div">
              <div class="container">
                <h5 class="card-title mb-4"> Product List </h5>
                <div class="search-table container-fluid">
                  <div class="row">
                    <div class="col-lg-2 col-sm mobile-div">
                        Product Type
                        <multiselect v-model="searchType" :options="productType" label="productTypeName" :allow-empty="false" :select-label="'Type'" :deselect-label="''" placeholder="Product Type" track-by="productTypeName"></multiselect>
                    </div>
                    <div class="col-lg-2 col-sm mobile-div">
                        Product Category
                        <multiselect v-model="searchCategory" :options="productCategory" label="productCategory" :allow-empty="false" :select-label="'Category'" :deselect-label="''" placeholder="Product Category" track-by="productCategory"></multiselect>
                    </div>
                    <div class="col-lg-2 col-sm mobile-div">
                        Brand
                        <multiselect v-model="searchBrand" :options="brandSelect" :allow-empty="false" :select-label="'Brand'" :deselect-label="''" placeholder="Product Brand"></multiselect>
                    </div>
                    <div class="col-lg-2 col-sm mobile-div">
                        Product Name
                        <input type="text" name="" class="form-control" placeholder="Product Name" v-model="searchProductName">
                    </div>
                    <div class="col-lg-2 col-sm mobile-div">
                        Product Status
                        <multiselect v-model="searchStatus" :options="productStatusSelect" label="statusName" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Product Status" track-by="statusName"></multiselect>
                    </div>
                    <div class="col-lg-2 col-sm mobile-div">
                        <button class="btn btn-primary mt-4" @click="searchData"> Search </button>
                    </div>
                  </div>
                </div>
                <div class="two-button text-center mt-2">
                  <button class="btn btn-outline-left block" @click="toProductCatalogPage">All Products</button>
                  <button class="btn btn-primary block" @click="toTopProductCatalogPage">Top Products</button>
                </div>
                <button class="btn btn-primary btn-sm mb-1 mt-2" @click="toPage('/product/add')"> Add </button>
                <table class="table table-sm table-bordered table-striped table-responsive-sm">
                  <thead class="">
                    <tr>
                      <th>Product ID</th>
                      <th>Brand</th>
                      <th>Product Name</th>
                      <th>Specification</th>
                      <th>Showing Order</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="loadingTable === false && totalData == '0'">
                      <td colspan="7" class="text-center">Data Not Available</td>
                    </tr>
                    <tr v-else-if="loadingTable === true">
                      <td colspan="7" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                    </tr>
                    <tr v-for="(data,index) in dataProduct" :key="index" v-else>
                      <td>{{ data.productId }}</td>
                      <td>{{ data.brand }}</td>
                      <td>{{ data.productTitle}}</td>
                      <td>{{ data.specifications }}</td>
                      <td>{{ data.showingOrder }}</td>
                      <td>
                        <label class="badge badge-danger" v-if="data.productStatus == '0'">Inactive</label>
                        <label class="badge badge-success" v-if="data.productStatus == '1'">Active</label>
                      </td>
                      <td><button class="btn btn-success btn-sm" @click="openModal('Change',data.productId, data.showingOrder, data.productTitle)"> <i class="fa fa-eye" aria-hidden="true"></i> </button>
                      <button class="btn btn-danger btn-sm mr-2" @click="openModal('Remove',data.productId, data.productTitle)"> <i class="fa fa-trash" aria-hidden="true"></i> </button></td>
                    </tr>
                  </tbody>
                </table>
                <div id="wrapperr">
                  <div id="c1">
                    <div class="alignLeft total-data">
                      Total Data {{ totalData }} 
                    </div>
                  </div>
                  <div id="c2">
                    <div class="pagination p8 alignRight">
                      <ul>
                        <a class="is-active link" @click="toDataPage(parseInt(currentPage)-1)" v-if="currentPage != 1"><li>{{'<'}}</li></a>
                        <a class="page"><li>{{ currentPage }} of {{ totalPage }} page</li></a>
                        <a class="is-active link" @click="toDataPage(parseInt(currentPage)+1)" v-if="currentPage != totalPage"><li>></li></a>
                      </ul>
                    </div>
                  </div>
                </div>​
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /#page-content-wrapper -->
      <!-- mudalToTop -->
      <div class="modal fade" id="modalRemove" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Remove Top Products</h4> 
                <h5 class="modal-title">{{ productNameChoose }}</h5> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
              <p>Are you sure to remove this product from top product?</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm" v-if="loadingButtonProcess == false" @click="submitRemoveProduct">Save</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;margin-right: 1px;">Save</button>

            </div>
          </div>
        </div>
      </div>
      <!-- mudalChangeStatus -->
      <div class="modal fade" id="modalChange" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Change Showing Order</h4> 
                <h5 class="modal-title">{{ productNameChoose }}</h5> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
              <div class="one-line">
                <div class="key">Showing Order</div>
                <div class="titik2">:</div>
                <div class="field">
                  <multiselect v-model="showingChoose" :options="allShowing" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Showing Order"></multiselect>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm" v-if="loadingButtonProcess == false" @click="submitChangeShowing">Save</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;margin-right: 1px;">Save</button>

            </div>
          </div>
        </div>
      </div>
      <!-- endModal -->
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import SideBar from '../SideBar'
export default {
  name: 'ProductPage',
  components:{
    SideBar,
    Multiselect
  },
  data () {
    return {
      spaceRegex: /[\u00A0\uFEFF\u202F]/g, 
      admin:"",
      adminId:"",
      permission:[],
      viewDashboard: false,
      viewOrder: false,
      viewReturn: false,
      viewProduct: false,
      viewPairing: false,
      viewReconcile: false,
      viewResolution: false,
      viewLessor: false,
      viewLessee: false,
      viewEmployee: false,
      editOrder: false,
      editReturn: false,
      editProduct: false,
      editPairing: false,
      editReconcile: false,
      editResolution: false,
      editLessor: false,
      editLessee: false,
      editEmployee: false,
      loadingButtonProcess: false,
      dataProduct: [],
      dataSearchProduct: [],
      totalPage:0,
      totalData:0,
      currentPage:1,
      orderId:"",
      companyName:"",
      statusOrder:"",
      loadingTable:true,
      productBrand:[],
      productBrandSearch:[],
      productSpec:[],
      productIdChoose:'',
      productNameChoose:'',
      statusChoose:'',
      showingChoose:'',
      allShowing:[],
      searchBrand:'All',
      search:false,
      searchCategory:{
        productCategory:'All'
      },
      productCategory:[],
      searchType:{
        productType:'All',
        productTypeName:'All'
      },
      productType:[],
      brandSelect:[],
      searchProductName:'',
      searchStatus:{
          status:'All',
          statusName:'All'
      },
      productStatusSelect:[
      {
         status:'All',
         statusName:'All' 
      },
      {
         status:'1',
         statusName:'Active' 
      },
      {
         status:'0',
         statusName:'Inactive' 
      },
      ]
    }
  },
  methods: {
    toTopProductCatalogPage(){
      this.$router.push({path:'/product/top',
            query: {
                productType: 'All',
                productTypeName: 'All',
                productCategory: 'All',
                productBrand: 'All',
                productStatus: 'All',
                productStatusName: 'All',
                productName: '',
                itemPerPage: 10,
                page:1
            }
        })
    },
    toProductCatalogPage(){
      this.$router.push({path:'/product',
            query: {
                productType: 'All',
                productTypeName: 'All',
                productCategory: 'All',
                productBrand: 'All',
                productStatus: 'All',
                productStatusName: 'All',
                productName: '',
                itemPerPage: 10,
                page:1
            }
        })
    },
    submitRemoveProduct(){
      this.loadingButtonProcess = true
      this.$http.post(process.env.REMOVE_TOP_PRODUCT,{
        productId: this.productIdChoose,
        adminId: this.adminId
      },{
        headers: {'Asani-Token':localStorage.getItem('jwt')}
      })
      .then(response => {
        if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
                button: "Ok",
            })
        }else if(response.data.status == 200){
            swal("Success", response.data.message, "success", {
                button: "Ok",
            })
            $('#modalRemove').modal('hide')
            this.sendLog(this.productIdChoose,30)
            this.getData()
            this.loadingButtonProcess = false
        }
      })
      .catch(error => {
        swal("Sorry", error.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
      })
    },
    openModal(x,y,z,a) {
      this.productIdChoose = y
      this.showingChoose = z
      // this.statusChoose = z
      this.productNameChoose = a
      if (x == 'Remove') {
        this.productNameChoose = z
      }
      $("#modal"+x).modal('show')
    },
    searchData(){
      let productType = ''
      let productTypeName = ''
      let productCategory = ''
      if (this.searchType != null) {
          if (this.searchType.length != 0) {
              productType = this.searchType.productType
              productTypeName = this.searchType.productTypeName
          }
      }
      if (this.searchCategory != null) {
          if (this.searchCategory.length != 0) {
              productCategory = this.searchCategory.productCategory
          }
      }
      if (this.searchBrand == null) {
          this.searchBrand = ''
      }
      this.$router.push({path:'/product/top', query: {
              productType: productType,
              productTypeName: productTypeName,
              productCategory: productCategory,
              productBrand: this.searchBrand,
              productStatus: this.searchStatus.status,
              productStatusName: this.searchStatus.statusName,
              productName: this.searchProductName,
              page:1
          }
      })
      this.getData();
    },
    toDataPage(pagePost){
      this.loadingTable = true
      let productType = ''
      let productTypeName = ''
      let productCategory = ''
      if (this.searchType != null) {
          if (this.searchType.length != 0) {
              productType = this.searchType.productType
              productTypeName = this.searchType.productTypeName
          }
      }
      if (this.searchCategory != null) {
          if (this.searchCategory.length != 0) {
              productCategory = this.searchCategory.productCategory
          }
      }
      if (this.searchBrand == null) {
          this.searchBrand = ''
      }
      this.$router.push({path:'/product/top', query: {
              productType: productType,
              productTypeName: productTypeName,
              productCategory: productCategory,
              productBrand: this.searchBrand,
              productStatus: this.searchStatus.status,
              productStatusName: this.searchStatus.statusName,
              productName: this.searchProductName,
              page:1
          }
      })
      this.getData();
    },
    toPage(e) {
      this.$router.push(e)
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    cekLogin(){
      if (localStorage.getItem('jwt') == null) {
        this.$router.push('/')
      }
    },
    cekPermission(){
      this.permission = localStorage.getItem('roles').replace(/"/g,"").replace("[","").replace("]","").split(",")
      for(var i=0; i < this.permission.length; i++){
        if( this.permission[i] == "1"){
          this.viewDashboard = true
        }
        if( this.permission[i] == "2.1"){
          this.viewOrder = true
        }
        if( this.permission[i] == "2.2"){
          this.editOrder = true
        }
        if( this.permission[i] == '3.1'){
          this.viewReturn = true
        }
        if( this.permission[i] == '3.2'){
          this.editReturn = true
        }
        if( this.permission[i] == '4.1'){
          this.viewProduct = true
        }
        if( this.permission[i] == '4.2'){
          this.editProduct = true
        }
        if( this.permission[i] == '5.1'){
          this.viewPairing = true
        }
        if( this.permission[i] == '5.2'){
          this.editPairing = true
        }
        if( this.permission[i] == '6'){
          this.viewReconcile = true
        }
        if( this.permission[i] == '7.1'){
          this.viewResolution = true
        }
        if( this.permission[i] == '7.2'){
          this.editResolution = true
        }
        if( this.permission[i] == '8.1'){
          this.viewLessor = true
        }
        if( this.permission[i] == '8.2'){
          this.editLessor = true
        }
        if( this.permission[i] == '9.1'){
          this.viewLessee = true
        }
        if( this.permission[i] == '9.2'){
          this.editLessee = true
        }
        if( this.permission[i] == '10'){
          this.viewEmployee = true
        }
      }
      if (this.viewProduct == false) {
        this.$router.push('/')
      }
    },
    sidebar(){
      $("#wrapper").toggleClass("toggled");
    },
    toDetail(id){
      this.$router.push('/product/detail/' + id)
    },
    getData(){
      this.loadingTable = true
      if (this.$route.query.productType != '') {
          this.searchType = {
              productType: this.$route.query.productType,
              productTypeName: this.$route.query.productTypeName
          }
      } else {
          this.searchType = null
      }
      if (this.$route.query.productCategory != '') {
          this.searchCategory = {
              productCategory: this.$route.query.productCategory
          }
      }
      if (this.$route.query.productStatus != '') {
          this.searchStatus = {
              status: this.$route.query.productStatus,
              statusName: this.$route.query.productStatusName
          }
      } else {
          this.searchStatus = null
      }
      this.searchBrand = this.$route.query.productBrand
      this.searchProductName = this.$route.query.productName
      this.currentPage = parseInt(this.$route.query.page)
      this.$http.post(process.env.SEARCH_TOP_PRODUCT,{
        productType: this.$route.query.productType,
        productCategory: this.$route.query.productCategory,
        productBrand: this.searchBrand !== null ? this.searchBrand.replace(this.spaceRegex, ' ') : this.searchBrand,
        productStatus: this.$route.query.productStatus,
        productName: this.searchProductName !== null ? this.searchProductName.replace(this.spaceRegex, ' ') : this.searchProductName,
        page:1
      },{
        headers: {'Asani-Token':localStorage.getItem('jwt')}
      })
      .then(response => {
        if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                    button: "Ok",
                  })
            }else{
              this.dataProduct = response.data.content.data
              this.productBrand = []
              this.productSpec = []
              this.totalPage = response.data.content.totalPage
              this.currentPage = response.data.content.currentPage
              this.totalData = response.data.content.totalData
              this.allShowing = response.data.content.allShowing
              this.loadingTable = false
            }
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
      })

      this.$http.get(process.env.GET_CATEGORY,{
        headers: {'Asani-Token':localStorage.getItem('jwt')}
      })
      .then(response => {
        if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                    button: "Ok",
                  })
            }else{
              this.productType.push({
                productType:'All',
                productTypeName:'All',
              })
              for (var i = 0; i < response.data.content.productType.length; i++) {
                this.productType.push({
                    productType:response.data.content.productType[i].productType,
                    productTypeName: response.data.content.productType[i].productTypeName
                })
              }
              this.productCategory.push({
                productCategory:'All'
              })
              for (var i = 0; i < response.data.content.productCategory.length; i++) {
                this.productCategory.push({
                    productCategory:response.data.content.productCategory[i].productCategory
                })
              }
              this.brandSelect = ['All']
              for (var i = 0; i < Object.values(response.data.content.productBrand).length; i++) {
                this.brandSelect.push(Object.values(response.data.content.productBrand)[i]
                )
              }
            }
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
      })
    },
    submitChangeStatus(){
      this.loadingButtonProcess = true
      this.$http.post(process.env.CHANGE_CATALOG_STATUS,{
        productId: this.productIdChoose,
        newStatus: this.statusChoose,
        adminId: this.adminId
      },{
        headers: {'Asani-Token':localStorage.getItem('jwt')}
      })
      .then(response => {
        if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
                button: "Ok",
            })
        }else if(response.data.status == 200){
            swal("Success", response.data.message, "success", {
                button: "Ok",
            })
            $('#modalChange').modal('hide')
            this.getData()
            this.loadingButtonProcess = false
        }
      })
      .catch(error => {
        swal("Sorry", error.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
      })
    },
    submitChangeShowing(){
      this.loadingButtonProcess = true
      this.$http.post(process.env.CHANGE_TOP_PRODUCT_SHOWING,{
        productId: this.productIdChoose,
        newShowing: this.showingChoose,
        adminId: this.adminId
      },{
        headers: {'Asani-Token':localStorage.getItem('jwt')}
      })
      .then(response => {
        if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
                button: "Ok",
            })
        }else if(response.data.status == 200){
            swal("Success", response.data.message, "success", {
                button: "Ok",
            })
            $('#modalChange').modal('hide')
            if (response.data.content.changeShowing == 'yes') {
                this.sendLog(this.productIdChoose,35)
            }
            this.getData()
            this.loadingButtonProcess = false
        }
      })
      .catch(error => {
        swal("Sorry", error.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
      })
    },
    sendLog(x,y){
        var today = new Date();
        var month = today.getMonth()+1
        if (month < 10) {
            month = '0'+month
        }
        var dateDay = today.getDate()
        if (dateDay < 10) {
            dateDay = '0'+dateDay
        }
        var hours = today.getHours()
        if (hours < 10) {
            hours = '0'+hours
        }
        var minutes = today.getMinutes()
        if (minutes < 10) {
            minutes = '0'+minutes
        }
        var second = today.getSeconds()
        if (second < 10) {
            second = '0'+second
        }
        var date = today.getFullYear()+'-'+month+'-'+dateDay;
        var time = hours + ":" + minutes + ":" + second;
        var dateTime = date+' '+time;
        var admin = this.admin
        var command = 'add-logs'
        var productName = this.productNameChoose !== null ? this.productNameChoose.replace(this.spaceRegex, ' ') : this.productNameChoose
        if (y == '35') {
            var newShowing = this.showingChoose
            this.$http.post(process.env.LOG_URL+"/product/"+x,{
                codeLogs: y,
                params: [productName, newShowing],
            },{
                headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
            })
            .catch(error => {
                console.log(error)
            })
        }else{
            this.$http.post(process.env.LOG_URL+"/product/"+x,{
                codeLogs: y,
                params: [productName],
            },{
                headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
            })
            .catch(error => {
                console.log(error)
            })
        }
    }
  },
  created(){
    this.getData()
    this.admin = localStorage.getItem('admin_name')
    this.adminId = localStorage.getItem('admin_id')
    this.cekLogin()
    this.cekPermission()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.key{
  width: 148px;
  margin: 7px 0px;
}
.titik2{
  margin: 7px 0px;
  padding: 0px 9px;
}
.field{
  width: 100%;
}
.one-line{
  display: flex;
}
.btn-outline-right{
  border:1px solid lightgray;
  border-left: none;
}

.btn-outline-left{
  border:1px solid lightgray;
  border-right: none;
}

.two-button{
  display: flex;
  box-shadow: 2px;
  width: 100%;
}

.block {
  display: block;
  width: 100%;
  font-size: 16px;
  cursor: pointer;
  text-align: center;
  border-radius: 0px;
}

.pagination{
padding: 0px 0;
}

.pagination ul{
margin: 0;
padding: 0;
list-style-type: none;
}

.pagination a{
display: inline-block;
padding: 1px 6px;
color: #222;
}

.p8 a{
background-color: #2797FB;
/*margin: auto 5px;*/
color: #fff;
/*font-weight: bold;*/
border: 1px solid #2797FB;
}

.p8 a:hover{
text-decoration: none;
}
.p8 a.page:hover{
text-decoration: none;
color: #fff;
}

.p8 .is-active{
background-color: #fff;
color: #2797FB;
}

.alignleft {
float: left;
}
.alignright {
float: right;
}

.pagg{
display: inline-flex;
overflow:auto;
}

.total-data{
padding: 11px 0px;
font-size: 14px;
color: #343A40;
}
#wrapperr{
  overflow:auto;
  margin: 5px 3px;
}

#c1{
 float:left;
}

#c2{
float: right;  
}

.search-table{
padding-bottom: 7px;
margin-top: -5px;
margin-left: -15px;
}
.active{
color: #2797FB;
}
.right-dropdown{
margin-left: 7px;
}
.account-div{
margin: 2px 2px;
}
.right-arrow{
margin-left: auto;
}
.brand-logo{
width: 120px;
}
.menu-title{
margin-left: 1.125rem;
}
.menu-title-order{
margin-left: 1.95rem;
}
.menu-title-payment{
margin-left: 1.525rem;
}

ul {
list-style-type: none;
margin: 0;
padding: 0;
/*width: 200px;*/
/*background-color: #f1f1f1;*/
}

li.sidebar a {
display: block;
color: #000;
padding: 8px 63px;
text-decoration: none;
}

li a.active {
background-color: #4CAF50;
color: white;
}

li a:hover:not(.active) {
background-color: #2797FB;
color: white;
}
.nav-side-menu {
overflow: auto;
font-family: verdana;
font-size: 12px;
font-weight: 200;
background-color: #2e353d;
position: fixed;
top: 0px;
width: 300px;
height: 100%;
color: #e1ffff;
}
.nav-side-menu .brand {
background-color: #23282e;
line-height: 50px;
display: block;
text-align: center;
font-size: 14px;
}
.nav-side-menu .toggle-btn {
display: none;
}
.nav-side-menu ul,
.nav-side-menu li {
list-style: none;
padding: 0px;
margin: 0px;
line-height: 35px;
cursor: pointer;
}
 .nav-side-menu ul :not(collapsed) .arrow:before,
 .nav-side-menu li :not(collapsed) .arrow:before {
  font-family: FontAwesome;
  content: "\f078";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}
.nav-side-menu ul .active,
.nav-side-menu li .active {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
}
.nav-side-menu ul .sub-menu li.active,
.nav-side-menu li .sub-menu li.active {
  color: #d19b3d;
}
.nav-side-menu ul .sub-menu li.active a,
.nav-side-menu li .sub-menu li.active a {
  color: #d19b3d;
}
.nav-side-menu ul .sub-menu li,
.nav-side-menu li .sub-menu li {
  background-color: #181c20;
  border: none;
  line-height: 28px;
  border-bottom: 1px solid #23282e;
  margin-left: 0px;
}
.nav-side-menu ul .sub-menu li:hover,
.nav-side-menu li .sub-menu li:hover {
  background-color: #020203;
}
.nav-side-menu ul .sub-menu li:before,
.nav-side-menu li .sub-menu li:before {
  font-family: FontAwesome;
  content: "\f105";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}
.nav-side-menu li {
  padding-left: 0px;
  border-left: 3px solid #2e353d;
  border-bottom: 1px solid #23282e;
}
.nav-side-menu li a {
  text-decoration: none;
  color: #e1ffff;
}
.nav-side-menu li a i {
  padding-left: 10px;
  width: 20px;
  padding-right: 20px;
}
.nav-side-menu li:hover {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  -ms-transition: all 1s ease;
  transition: all 1s ease;
}
@media (max-width: 767px) {
  .nav-side-menu {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
  }
  .nav-side-menu .toggle-btn {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10 !important;
    padding: 3px;
    background-color: #ffffff;
    color: #000;
    width: 40px;
    text-align: center;
  }
  .brand {
    text-align: left !important;
    font-size: 22px;
    padding-left: 20px;
    line-height: 50px !important;
  }
}
@media (min-width: 767px) {
  .nav-side-menu .menu-list .menu-content {
    display: block;
  }
}
@media (max-width: 573px){
  .mobile-div{
    padding: 2px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Product/ProductTopPage.vue